<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "App",
  created() {
   
  }
};
</script>

<style media="print">
@page {
  size: auto;
  margin: 0mm;
}
</style>
